import { WarningAmberRounded } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { faintErrorBg } from "../../../../theme/palette";
export default function CellErrorIcon(props) {
    var error = props.error;
    var _a = useState(false), open = _a[0], setOpen = _a[1];
    useEffect(function () {
        if (error)
            setOpen(true);
    }, [error]);
    var handleToggle = function () {
        setOpen(function (prev) { return !prev; });
    };
    return error ? /*#__PURE__*/ React.createElement(Tooltip, {
        arrow: true,
        title: error,
        open: open,
        onClose: handleToggle,
        placement: "bottom-start",
        slotProps: {
            tooltip: {
                sx: {
                    p: 1.5,
                    top: 16,
                    color: 'red',
                    borderRadius: 2,
                    bgcolor: faintErrorBg,
                    boxShadow: '0px 8px 10px 0px rgba(0,0,0,0.07)'
                }
            },
            arrow: {
                sx: {
                    color: faintErrorBg
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(IconButton, {
        size: "small",
        disableRipple: true,
        onClick: handleToggle,
        color: "error"
    }, /*#__PURE__*/ React.createElement(WarningAmberRounded, {
        fontSize: "small",
        color: "error"
    }))) : null;
}
